exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cell-content[data-v-31c43c28]{white-space:pre-wrap}.break-all[data-v-31c43c28]{word-break:break-all}.picture-cell[data-v-31c43c28]{text-align:center}.profile-picture[data-v-31c43c28]{border-radius:50%;width:60px;height:60px;object-fit:cover}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31c43c28","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/TableCell.vue
// module id = 590
// module chunks = 38